<template>
    <div class="my-item z-info">
        <div class="news-change" style="margin-bottom:20px;">
            <RadioGroup v-model="newsAudit" type="button" @on-change="init">
                <!-- <Radio label="1">布展车证</Radio> -->
                <Radio label="2">撤展车证</Radio>
            </RadioGroup>
        </div>
        <template>
            <div style="min-height: 400px">
                <Row :gutter="30">
                    <Col :md="12" :xl="8" :xxl="6" class="w-20">
                        <div class="addPro pro" @click="addCar">
                            <i class="icon iconfont icon-jia3"></i>
                            <span>添加车证</span>
                        </div>
                    </Col>
                    <Col
                        :md="12"
                        :xl="8"
                        :xxl="6"
                        v-for="(item, index) in CarList"
                        :key="'releaseInt-' + index"
                        class="w-20"
                        v-if="CarList.length"
                    >
                        <div class="pro">
                            <div class="pro-top">
                                <div class="pro-top-l">
                                    <h3>联系人：{{ item.contactName }}</h3>
                                    <p>联系电话：{{ item.contactPhone }}</p>
                                    <p>司机姓名：{{ item.driverName }}</p>
                                    <p>司机电话：{{ item.driverPhone }}</p>
                                </div>
                                <div class="pro-top-r">
                                    <h4>{{ item.number }}</h4>
                                    <p>车辆吨位：{{ item.tonnage }}吨</p>
                                </div>
                            </div>
                            <div class="pro-tool">
                                <div
                                    class="pro-tool-item"
                                    @click="editModal(item)"
                                    style="color: #1890ff"
                                >
                                    编辑
                                </div>
                                <div class="pro-tool-line"></div>
                                <el-button
                                    type="text"
                                    :loading="loadingBut == item.id"
                                    class="pro-tool-item"
                                    @click="downloadCard(item)"
                                    style="color: #1890ff"
                                >
                                    下载车证
                                </el-button>
                                <div class="pro-tool-line"></div>
                                <div class="pro-tool-item z-del">
                                    <Poptip
                                        confirm
                                        title="您确认删除这条内容吗？"
                                        @on-ok="delItem(item)"
                                        style="color: #ff0000"
                                        >删除</Poptip
                                    >
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <!-- <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div> -->
            </div>
        </template>
        <addCar
            :show="carShow"
            :newsAudit="newsAudit"
            @close="closeModal"
            :ModalTitle="ModalTitle"
            :options="options"
        ></addCar>
        <!-- <emptyList v-else @change="Add()"></emptyList> -->
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
// import emptyList from "@components/emptyList/emptyList";
import addCar from './add-car'
// import axios from 'axios'

export default {
    name: 'exhibition-car-yes',
    props: ['addShow'],
    data() {
        return {
            loadingBut: '',
            deleted: false,
            edit: false,
            list: null,
            editInfo: null,
            delInfo: null,
            newsAudit: '2',
            pageSize: 20,
            pageIndex: 1,
            totalCount: 0,
            timer: null,
            carShow: false,
            ModalTitle: '', // 弹框标题
            CarList: [],
            options: {},
        }
    },
    watch: {
        addShow(val) {
            if (val) {
                this.addCar()
            }
        },
    },
    computed: {
        ...mapGetters({
            exhibition: 'loginModule/getExhibition',
        }),
        header() {
            return this.$store.state.header
        },
        joinInfo() {
            return JSON.parse(localStorage.getItem('vuex')).loginModule.joinInfo
        },
        option() {
            return {
                CompId: this.company.id,
                PageSize: this.pageSize,
                PageIndex: this.pageIndex,

                Wheres: {
                    Type: 0,
                    Wheres: {
                        WhereGroupOperator: 0,
                        Predicates: [
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 0,
                                    Label: 'IsApply',
                                    Value: 1,
                                },
                            },
                        ],
                    },
                },
            }
        },
    },
    components: {
        addCar,
    },
    created() {
        this.init()
    },
    methods: {
        ...mapActions({
            getCardTemplateZip: 'hostSetModule/getCardTemplateZip',
            templatePDF: 'hostSetModule/templatePDF',
            editVehicleDownAudit: 'hostAuditModule/editVehicleDownAudit',
        }),
        closeModal() {
            // 关闭弹框
            this.carShow = false

            setTimeout(() => {
                this.getCarList()
            }, 1000)
            this.$emit('closeModal')
        },
        addCar() {
            // 2026-08-27 修改：车证暂未开始，点击提示“暂未开始，敬请期待”（打开弹窗代码注释保留，后续可恢复）
            this.$Message.warning('暂未开始，敬请期待')
            // this.carShow = true
            // this.ModalTitle = '添加车证'
            // this.options = {
            //     msg: null,
            //     model: null,
            // }
        },
        editModal(item) {
            this.carShow = true
            this.ModalTitle = '编辑车证'
            this.options = {
                msg: item,
                model: 'edit',
                type: '0',
            }
        },
        // 下载车证
        async downloadCard(item) {
            console.log(this.exhibition)
            this.loadingBut = item.id
            let currentType =
                this.newsAudit == '2' ? 'Dismantling' : 'ExhibitionArrange'
            let req = {
                exId: this.exhibition.id,
                vehicaleId: item.id,
                type: currentType,
            }
            let bool = await this.templatePDF(req)
            if (bool.successed) {
                const fileUrl = bool.info.filePaht

                // const link = document.createElement('a')
                // link.href = fileUrl
                // // link.setAttribute('download', '') // 设置下载属性为true，触发下载
                // link.style.display = 'none';
                // document.body.appendChild(link)
                // link.click()
                // document.body.removeChild(link)
                // this.$Message.success('操作成功！')
                fetch(fileUrl).then(response => response.blob()).then(blob => {
                    // 创建一个临时的URL对象
                    const url = URL.createObjectURL(blob);
                    // 创建一个隐藏的<a>标签，并设置其href属性为临时URL
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = ''; // 设置下载的文件名
                    a.style.display = 'none';
                    // 将<a>标签添加到文档中，并模拟点击下载
                    document.body.appendChild(a);
                    a.click();
                    // 下载完成后，移除<a>标签和临时URL对象
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    this.$Message.success('操作成功！')
                }).catch(error => {
                });

                
            } else {
                if (bool.errors.length > 0) {
                    this.$Message.error(bool.errors[0].description)
                } else {
                    this.$Message.error('操作失败')
                }
            }
            this.loadingBut = ''
        },
        delItem(item) {
            // 删除
            this.$http
                .delete(`/api/Vehicle`, {data: {id: item.id}, ...this.header})
                .then((res) => {
                    if (res.status === 200 && res.data.successed) {
                        this.$Message.success('删除成功！')
                        this.pass(res.data.info)
                    } else {
                        this.$Message.error('删除失败，请重新尝试')
                    }
                })
        },
        async pass(item) {
            const opt = {
                id: item.id,
                status: 1,
            }

            const bool = await this.editVehicleDownAudit(opt)
            if (bool && bool.successed) {
                this.$Message.success('审核通过')
                this.getCarList()
            } else {
                if (bool.errors.description) {
                    this.$Message.error(bool.errors.description)
                } else {
                    this.$Message.error('操作失败，请重新尝试')
                }
            }
        },
        init() {
            this.getCarList()
        },
        getCarList() {
            let currentType =
                this.newsAudit == '2' ? 'Dismantling' : 'ExhibitionArrange'
            // 已确认的
            // this.$http.get(`/api/vehicle/?joinId=${this.joinInfo.joinId}`,this.header)
            //           .then(res=>{
            //             if(res.status === 200 && res.data.length){
            //               this.CarList = res.data;
            //               console.log("已确认：",this.CarList)
            //             }
            //           })
            // axios
            // .get(`http://192.168.0.15:59802/api/Vehicle/GetListByJoinId?joinId=${this.joinInfo.joinId}&type=${currentType}`)
            // .then(response => (this.info = response))
            // .catch(function (error) { // 请求失败处理
            //   console.log(error);
            // });
            this.$http
                .get(
                    `/api/Vehicle/GetListByJoinId?joinId=${
                        this.joinInfo.joinId
                    }&type=${currentType}`,
                    this.header
                )
                .then((res) => {
                    if (res.status === 200 && res.data.length) {
                        this.CarList = res.data
                        console.log('已确认：', this.CarList)
                    } else {
                        this.CarList = []
                    }
                })
        },
    },
}
</script>

<style scoped lang="scss">
.my-item {
    min-width: 600px;
    padding: 24px;

    &-box {
        background-color: #fff;
        margin-bottom: 30px;
    }

    .addPro {
        padding: 40px;
        .icon {
            font-size: 60px;
            text-align: center;
            display: block;
            color: #999;
        }
        span {
            display: block;
            font-size: 18px;
            color: #999;
            text-align: center;
            position: relative;
            top: -5px;
        }
    }
    .pro {
        margin-bottom: 20px;
        position: relative;
        height: 210px;
        background-color: #fafafa;
        box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
        &-top {
            width: 100%;
            background: #fff;
            padding: 20px;
            display: flex;
            &-l {
                width: 65%;
                h3 {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 20px;
                    color: #333;
                    padding-bottom: 10px;
                }
                p {
                    font-size: 14px;
                    line-height: 16px;
                    padding: 8px 0;
                    color: #333;
                }
            }
            &-r {
                h4 {
                    font-size: 18px;
                    line-height: 32px;
                    color: #333;
                    width: 100%;
                    border-radius: 5px;
                    background-color: #d3e7ff;
                    font-weight: 400;
                    text-align: center;
                }
                p {
                    font-size: 14px;
                    line-height: 16px;
                    padding: 8px 0;
                    color: #333;
                }
            }
        }

        &-tool {
            display: flex;
            height: 48px;
            align-items: center;
            justify-content: space-around;
            background-color: #f7f9fa;

            &-item {
                flex: 1;
                line-height: 48px;
                font-size: 14px;
                color: #808080;
                cursor: pointer;
                text-align: center;
                &:hover {
                    color: #1890ff;
                }

                &.z-del {
                    &:hover {
                        color: #f00;
                    }
                }
            }

            &-line {
                background-color: #e8e8e8;
                font-size: 20px;
                width: 1px;
                height: 22px;
                background-color: #e8e8e8;
            }
        }
    }

    .my-page {
        padding-bottom: 50px;
    }
}
</style>
